import { render, staticRenderFns } from "./ScreenLaudoEcocardiodopplerFetal.vue?vue&type=template&id=81b3b214&lang=true&"
import script from "./ScreenLaudoEcocardiodopplerFetal.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoEcocardiodopplerFetal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports